import { render } from "./AllChats.vue?vue&type=template&id=7454c6b0"
import script from "./AllChats.vue?vue&type=script&lang=js"
export * from "./AllChats.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__